import { apiSlice } from '@/features/api/apiSlice';

export type UploadedAsset = {
  id: string;
  url: string;
  filename: string;
  contentType: string;
  sizeBytes: number;
  createdAt: string;
};

export type StorageUsage = {
  bytesUsed: number;
  bytesQuota: number;
  fileCount: number;
};

export const uploadsApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listAssets: b.query<UploadedAsset[], void>({
      query: () => '/uploads',
      providesTags: (rows) =>
        rows
          ? [...rows.map((r) => ({ type: 'Asset' as const, id: r.id })), { type: 'Asset', id: 'LIST' }]
          : [{ type: 'Asset', id: 'LIST' }],
    }),
    storageUsage: b.query<StorageUsage, void>({
      query: () => '/uploads/usage',
      providesTags: [{ type: 'Asset', id: 'USAGE' }],
    }),
    uploadAsset: b.mutation<UploadedAsset, File>({
      query: (file) => {
        const form = new FormData();
        form.append('file', file);
        return {
          url: '/uploads',
          method: 'POST',
          body: form,
          // RTK Query auto-detects FormData and skips JSON serialization;
          // Content-Type with boundary is set by the browser.
        };
      },
      invalidatesTags: [
        { type: 'Asset', id: 'LIST' },
        { type: 'Asset', id: 'USAGE' },
      ],
    }),
    deleteAsset: b.mutation<void, string>({
      query: (id) => ({ url: `/uploads/${id}`, method: 'DELETE' }),
      invalidatesTags: [
        { type: 'Asset', id: 'LIST' },
        { type: 'Asset', id: 'USAGE' },
      ],
    }),
  }),
});

export const {
  useListAssetsQuery,
  useStorageUsageQuery,
  useUploadAssetMutation,
  useDeleteAssetMutation,
} = uploadsApi;
